import CitationPill from 'ai-components-ui-library/components/citation/CitationPill';
import CrmRecordChip from 'ai-components-ui-library/components/crm/CrmRecordChip';
import Citation from '../../../../components/text/MarkdownWithCitations/Citation';
import { getCrmCitationObjectNameAndIcon } from '../../../../utils/citationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const COMBINED_MARKER_REGEX = /\[SEARCH_?RESULT_?(\d+)\]|\[CRM_RECORD:([^:\]]+):([^:\]]+):([^\]]+)\]/g;
const buildCrmChipsByKey = chips => new Map(chips.map(chip => [`${chip.objectTypeId}:${chip.objectId}`, chip]));
export const parseTextWithMarkers = ({
  text,
  message,
  callbacks,
  sectionId
}) => {
  const {
    citations = [],
    crmRecordChips = []
  } = message !== null && message !== void 0 ? message : {};
  const crmChipsByKey = buildCrmChipsByKey(crmRecordChips);
  const nodes = [];
  let lastIndex = 0;
  for (const match of text.matchAll(COMBINED_MARKER_REGEX)) {
    var _match$index;
    const matchStart = (_match$index = match.index) !== null && _match$index !== void 0 ? _match$index : 0;
    if (matchStart > lastIndex) {
      nodes.push(text.slice(lastIndex, matchStart));
    }
    const [fullMatch, citationNumber, objectTypeId, objectId, displayName] = match;
    if (citationNumber !== undefined) {
      const citationArrayIndex = parseInt(citationNumber, 10) - 1;
      const citation = citationArrayIndex >= 0 && citationArrayIndex < citations.length ? citations[citationArrayIndex] : undefined;
      if (citation) {
        var _callbacks$CITATION, _callbacks$CITATION2, _callbacks$CITATION3, _callbacks$CITATION4, _callbacks$CITATION5;
        nodes.push( /*#__PURE__*/_jsx(Citation, {
          citation: citation,
          displayNumber: citationNumber,
          message: message,
          onCitationFeedback: callbacks === null || callbacks === void 0 || (_callbacks$CITATION = callbacks.CITATION) === null || _callbacks$CITATION === void 0 ? void 0 : _callbacks$CITATION.onCitationFeedback,
          onCitationClick: callbacks === null || callbacks === void 0 || (_callbacks$CITATION2 = callbacks.CITATION) === null || _callbacks$CITATION2 === void 0 ? void 0 : _callbacks$CITATION2.onCitationClick,
          onCitationOpen: callbacks === null || callbacks === void 0 || (_callbacks$CITATION3 = callbacks.CITATION) === null || _callbacks$CITATION3 === void 0 ? void 0 : _callbacks$CITATION3.onCitationOpen,
          handledCitationTypes: callbacks === null || callbacks === void 0 || (_callbacks$CITATION4 = callbacks.CITATION) === null || _callbacks$CITATION4 === void 0 ? void 0 : _callbacks$CITATION4.handledCitationTypes,
          onCitationOpened: callbacks === null || callbacks === void 0 || (_callbacks$CITATION5 = callbacks.CITATION) === null || _callbacks$CITATION5 === void 0 ? void 0 : _callbacks$CITATION5.onCitationOpened
        }, `citation-${matchStart}`));
      } else {
        nodes.push( /*#__PURE__*/_jsx(CitationPill, {
          label: citationNumber,
          disabled: true
        }, `citation-${matchStart}`));
      }
    } else if (objectTypeId && objectId && displayName) {
      var _chip$urls, _chip$secondaryProper, _callbacks$CRM_RECORD3, _callbacks$CRM_RECORD4, _callbacks$CRM_RECORD5;
      const chip = crmChipsByKey.get(`${objectTypeId}:${objectId}`);
      nodes.push( /*#__PURE__*/_jsx(CrmRecordChip, {
        objectTypeId: objectTypeId,
        objectId: objectId,
        displayName: displayName,
        urls: (_chip$urls = chip === null || chip === void 0 ? void 0 : chip.urls) !== null && _chip$urls !== void 0 ? _chip$urls : [],
        primaryProperty: chip === null || chip === void 0 ? void 0 : chip.primaryProperty,
        secondaryProperties: (_chip$secondaryProper = chip === null || chip === void 0 ? void 0 : chip.secondaryProperties) !== null && _chip$secondaryProper !== void 0 ? _chip$secondaryProper : [],
        icon: getCrmCitationObjectNameAndIcon({
          objectTypeId
        }).icon,
        onViewImpression: (callbackObjectTypeId, callbackObjectId) => {
          var _callbacks$CRM_RECORD, _callbacks$CRM_RECORD2;
          callbacks === null || callbacks === void 0 || (_callbacks$CRM_RECORD = callbacks.CRM_RECORD_CHIP) === null || _callbacks$CRM_RECORD === void 0 || (_callbacks$CRM_RECORD2 = _callbacks$CRM_RECORD.onViewImpression) === null || _callbacks$CRM_RECORD2 === void 0 || _callbacks$CRM_RECORD2.call(_callbacks$CRM_RECORD, callbackObjectTypeId, callbackObjectId, sectionId);
        },
        onChipClick: callbacks === null || callbacks === void 0 || (_callbacks$CRM_RECORD3 = callbacks.CRM_RECORD_CHIP) === null || _callbacks$CRM_RECORD3 === void 0 ? void 0 : _callbacks$CRM_RECORD3.onChipClick,
        onPopoverShown: callbacks === null || callbacks === void 0 || (_callbacks$CRM_RECORD4 = callbacks.CRM_RECORD_CHIP) === null || _callbacks$CRM_RECORD4 === void 0 ? void 0 : _callbacks$CRM_RECORD4.onPopoverShown,
        onPopoverLinkClick: callbacks === null || callbacks === void 0 || (_callbacks$CRM_RECORD5 = callbacks.CRM_RECORD_CHIP) === null || _callbacks$CRM_RECORD5 === void 0 ? void 0 : _callbacks$CRM_RECORD5.onPopoverLinkClick
      }, `crm-chip-${matchStart}`));
    } else {
      nodes.push(fullMatch);
    }
    lastIndex = matchStart + fullMatch.length;
  }
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }
  return nodes;
};
const MARKER_PRESENCE_REGEX = /\[SEARCH_?RESULT_?\d+\]|\[CRM_RECORD:[^:\]]+:[^:\]]+:[^\]]+\]/;
export const textContainsMarkers = text => MARKER_PRESENCE_REGEX.test(text);
export const parseTextIfMarkers = (text, message, callbacks, sectionId) => {
  if (!message || !textContainsMarkers(text)) {
    return text;
  }
  return parseTextWithMarkers({
    text,
    message,
    callbacks,
    sectionId
  });
};